export default __webpack_public_path__ + "static/apple-pay.png";